
import * as React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const AuthNavigation = () => {
  return (
    <div className="bg-white border-b">
      <div className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2 text-primary hover:text-primary/80 transition-colors">
            <ArrowLeft className="h-4 w-4" />
            <span className="font-medium">Back to Home</span>
          </Link>
          <div className="text-sm text-gray-600">
            <span className="text-gray-400">Home</span> / <span className="font-medium">Authentication</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthNavigation;
